<template>
  <div class="container mt-4">
    <h2>Gestión de Categorías</h2>
    <div class="card">
      <div class="card-body">
        <categoria-form 
          :edit-mode="!!categoriaToEdit"
          :categoria-to-edit="categoriaToEdit"
          @categoria-added="loadCategorias"
          @categoria-updated="handleCategoriaUpdated"
          @cancel-edit="categoriaToEdit = null"
        />
        
        <div class="list-group mt-4">
          <div 
            v-for="categoria in categorias" 
            :key="categoria.id"
            class="list-group-item d-flex justify-content-between align-items-center"
          >
            {{ categoria.nombre }}
            <div class="btn-group">
              <button 
                class="btn btn-sm btn-outline-primary"
                @click="editCategoria(categoria)"
              >
                Editar
              </button>
              <button 
                class="btn btn-sm btn-outline-danger"
                @click="deleteCategoria(categoria.id)"
              >
                Eliminar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import axios from '../config/axios';
import CategoriaForm from '../components/CategoriaForm.vue';

export default {
  name: 'CategoriasView',
  
  components: {
    CategoriaForm
  },
  
  setup() {
    const categorias = ref([]);
    const categoriaToEdit = ref(null);
    const loading = ref(false);
    const error = ref(null);
    
    const loadCategorias = async () => {
      try {
        loading.value = true;
        error.value = null;
        
        const { data } = await axios.get('/api/categorias');
        categorias.value = data;
      } catch (err) {
        console.error('Error:', err);
      }
    };
    
    const editCategoria = (categoria) => {
      categoriaToEdit.value = { ...categoria };
    };
    
    const handleCategoriaUpdated = () => {
      loadCategorias();
      categoriaToEdit.value = null;
    };
    
    const deleteCategoria = async (id) => {
      if (!id) {
        console.error('Error: Intento de eliminar una categoría con ID null o undefined');
        alert('Error: No se puede eliminar esta categoría porque no tiene un ID válido');
        return;
      }
      
      if (!confirm('¿Estás seguro de eliminar esta categoría?')) return;
      
      try {
        await axios.delete(`/api/categorias/${id}`);
        await loadCategorias();
      } catch (error) {
        console.error('Error:', error);
        alert('Error al eliminar la categoría');
      }
    };
    
    onMounted(loadCategorias);
    
    return {
      categorias,
      categoriaToEdit,
      loadCategorias,
      editCategoria,
      deleteCategoria,
      handleCategoriaUpdated
    };
  }
};
</script> 